import GATSBY_COMPILED_MDX from "/tmp/build/53bb150e/site-repo/packages/electricui.com/src/pages/docs/components/AreaChart.md";
import {Column, Content, Message} from 'rbx';
import {rhythm, scale} from 'utils/typography';
import Docs from 'layouts/Docs';
import {OpenGraph} from '../layouts/OpenGraph';
import Layout from '../layouts/index';
import {Link} from 'gatsby';
import {MDXProvider} from '@mdx-js/react';
import PassPageContext from 'components/PassPageContext';
import React from 'react';
import TableOfContents from 'components/TableOfContents';
import {graphql} from 'gatsby';
import mdxComponents from './mdx-components';
import slugify from 'utils/slugify';
import {Breadcrumbs} from 'components/Breadcrumbs';
function DocsPageTemplate(props) {
  const {pageContext, data} = props;
  if (!data) {
    console.error(props, 'no data');
    return null;
  }
  const post = pageContext;
  const {data: {mdx: {tableOfContents}}} = props;
  const toc = !tableOfContents.items || tableOfContents.items.length === 0 ? null : React.createElement("div", null, React.createElement(TableOfContents, {
    items: tableOfContents.items
  }));
  return React.createElement(Layout, {
    location: props.location
  }, React.createElement(OpenGraph, {
    title: `${post.frontmatter.title} - Electric UI`,
    keywords: post.frontmatter.keywords,
    description: post.frontmatter.description,
    type: post.frontmatter.category === 'guide' ? 'article' : 'website',
    image: post.image,
    imageHeight: post.imageHeight,
    imageWidth: post.imageWidth
  }), React.createElement(Docs, {
    location: props.location,
    currentTitle: post.frontmatter.title,
    toc: toc
  }, post.breadcrumbs ? React.createElement(Breadcrumbs, {
    breadcrumbs: post.breadcrumbs
  }) : null, React.createElement("h1", {
    id: slugify(post.frontmatter.title)
  }, post.frontmatter.title), React.createElement("main", {
    style: {
      display: 'block',
      marginBottom: rhythm(1),
      marginTop: rhythm(1)
    }
  }, React.createElement(PassPageContext.Provider, {
    value: pageContext
  }, React.createElement(MDXProvider, {
    components: mdxComponents
  }, props.children)))));
}
DocsPageTemplate
export default function GatsbyMDXWrapper(props) {
  return React.createElement(DocsPageTemplate, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const pageQuery = graphql`
  query($slug: String!) {
    mdx(fields: { slug: { eq: $slug } }) {
      fields {
        slug
      }
      body
      tableOfContents
      frontmatter {
        keywords
        description
        title
        category
      }
      parent {
        ... on File {
          relativePath
        }
      }
    }
  }
`;
